<nz-drawer
	[nzClosable]="false"
	[(nzVisible)]="filtersDrawer"
	nzPlacement="right"
	(nzOnClose)="filtersDrawer = false"
	[nzTitle]="'common_filters-title' | translate"
	nzWidth="300"
>
    <hpf-about-filters [searchParams]="searchParams" [resetPage]="true"></hpf-about-filters>
</nz-drawer>
<hpf-about-list-top-bar
    [title]="'about_common_name' | translate"
	(filterEvent)="filtersDrawer = true"
	[searchParams]="searchParams"
	(createEvent)="onCreate()"
    [createButton]="'common_create' | translate"
></hpf-about-list-top-bar>
<div class="container-fluid px-5">
    <div class="row my-5">
        <div class="col-12">
            <hpf-about-table
                [searchParams]="searchParams"
                [enableMultiSelect]="true"
                [showActions]="true"
                (select)="onSelect($event)"></hpf-about-table>
        </div>
    </div>
</div>
